import { Component, Input, ViewChild, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectCounters } from 'src/app/data/store/selectors/users.selectors';
import { arrowRight, arrowRightLight, befreeUrlValues } from '../../constants';
import { CurrentPlatform, TextSizes, TextType } from '../../enums';
import { selectCurrentPlatform } from '../../../data/store/selectors/platform.selectors';
import { IonContent, IonicModule } from '@ionic/angular';
import { Location, NgClass, AsyncPipe } from '@angular/common';
import { ITabsLinks } from '../../interfaces';
import { TextComponent } from '../text/text.component';
import { UtilsService } from '../../services/utils.service';
import { AppInfoService } from '../../services/app-info/app-info.service';

@Component({
  selector: 'app-ion-page-container',
  templateUrl: './ion-page-container.component.html',
  styleUrls: ['./ion-page-container.component.scss'],
  imports: [IonicModule, NgClass, TextComponent, RouterLink, RouterLinkActive, AsyncPipe],
})
export class IonPageContainerComponent {
  private _router = inject(Router);
  private _store = inject(Store);
  private location = inject(Location);
  private _utils = inject(UtilsService);
  private _appInfoService = inject(AppInfoService);

  @ViewChild(IonContent) content: IonContent | undefined;

  @Input() headerName = '';

  @Input() isHeaderTranslucent = false;

  @Input() isNeedBack = false;

  @Input() backNavigateUrl?: string;

  @Input() isDataLoaded$: Observable<any> | undefined;

  @Input() needFooter = true;

  @Input() isModalView = false;

  @Input() tabsLinks: ITabsLinks[] = [];

  @Input() isShowVersion = false;

  public currentPlatform$: Observable<CurrentPlatform | null> | undefined =
    this._store.select(selectCurrentPlatform);

  public counters$: Observable<Record<string, number> | null> = this._store.select(selectCounters);

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly arrowRight = arrowRight;

  public readonly arrowRightLight = arrowRightLight;

  public readonly CurrentPlatform = CurrentPlatform;

  public readonly appInfo = this._appInfoService.appInfo;

  public back() {
    if (this.isModalView) {
      this._utils.dismissModal();
      return;
    }

    if (this.backNavigateUrl) {
      this._router.navigate([this.backNavigateUrl]);
      return;
    }

    if (typeof window !== 'undefined' && window.history.length <= 1) {
      void this._router.navigateByUrl(`/${befreeUrlValues.dashboard}`);
      return;
    }
    this.location.back();
  }
}
